(function (root) {
  const policy = {
    visit(raw, now, timeout) {
      if (!raw || raw.version !== 2 || !Number.isFinite(raw.lastSeen) || now < raw.lastSeen || now - raw.lastSeen >= timeout) {
        return { version: 2, lastSeen: now, elapsed: 0, shown: false };
      }
      return { version: 2, lastSeen: raw.lastSeen, elapsed: Math.max(0, Number(raw.elapsed) || 0), shown: raw.shown === true };
    },
    advance(raw, now, delta, timeout) {
      const visit = this.visit(raw, now, timeout);
      // Concurrent visible tabs must not double-count the same browsing time.
      visit.elapsed = Math.min(60000, visit.elapsed + Math.max(0, Math.min(delta, now - visit.lastSeen)));
      visit.lastSeen = now;
      return visit;
    },
    eligible(visit, subscribed, delay) { return !subscribed && !visit.shown && visit.elapsed >= delay; },
    excluded(path) { return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts|account|challenge)(?:\/|$)/i.test(path); }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = policy;
  else root.BobboPopupPolicy = policy;
})(globalThis);

(() => {
  'use strict';
  if (typeof document === 'undefined') return;
  let config = {};
  try { config = JSON.parse(document.getElementById('BobboOfferConfig')?.textContent || '{}'); } catch { /* No promotion without valid configuration. */ }
  window.BobboOffers = { config };
  const policy = window.BobboPopupPolicy;
  const visitKey = 'bobbo_offer_visit_v2';
  const subscribedKey = 'bobbo_offer_subscribed_v2';
  let storage;
  for (const name of ['localStorage', 'sessionStorage']) {
    try { const candidate = window[name]; candidate.setItem('bobbo_offer_storage_check', '1'); candidate.removeItem('bobbo_offer_storage_check'); storage = candidate; break; } catch { /* Fall back when browser storage is unavailable. */ }
  }
  const memory = new Map();
  const read = key => { try { return JSON.parse(storage?.getItem(key) ?? memory.get(key) ?? 'null'); } catch { return null; } };
  const write = (key, value) => { const text = JSON.stringify(value); memory.set(key, text); try { storage?.setItem(key, text); } catch { storage = undefined; } };
  function initializePopup(popup) {
    if (popup.dataset.initialized) return;
    popup.dataset.initialized = 'true';
    const forced = new URLSearchParams(location.search).get('bobbo_popup') === '1';
    const success = Boolean(popup.querySelector('[data-offer-success]'));
    const returned = success || Boolean(popup.querySelector('[data-offer-errors]'));
    const subscribed = () => popup.dataset.subscribed === 'true' || read(subscribedKey) === true;
    if (success) write(subscribedKey, true);
    // Account recognition is evaluated on each page; do not label everyone using a shared browser.
    if (popup.dataset.designMode === 'true' && !forced) return;
    if (policy.excluded(location.pathname) && !forced) return;
    if (subscribed() && !returned && !forced) return;
    const timeout = Math.max(5, Number(popup.dataset.visitMinutes) || 30) * 60000;
    const delay = Math.max(3, Number(popup.dataset.delay) || 5) * 1000;
    let previousFocus, specialOpened = false, lastTick = Date.now();
    let visit = policy.visit(read(visitKey), lastTick, timeout);
    visit.lastSeen = lastTick;
    write(visitKey, visit);
    const scale = () => popup.style.setProperty('--bobbo-popup-scale', String(Math.min(1, innerWidth / 800, (innerHeight - 20) / 746)));
    const cleanup = () => { clearInterval(timer); window.removeEventListener('resize', scale); document.removeEventListener('visibilitychange', visibility); window.removeEventListener('storage', syncSubscriber); };
    const close = () => popup.close();
    popup.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', close));
    popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
    popup.addEventListener('close', () => {
      document.body.classList.remove('bobbo-popup-open');
      if (!document.querySelector('dialog[open]') && previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    });
    popup.querySelector('form')?.addEventListener('submit', () => {
      const selected = popup.querySelector('[name="bobbo_personality"]:checked')?.value;
      const allowed = ['sofa_scratcher', 'climbing_explorer', 'sleepy_lounger', 'tiny_boss'];
      const tags = popup.querySelector('[data-offer-tags]');
      if (tags) tags.value = 'newsletter,bobbo_popup' + (allowed.includes(selected) ? ',cat_' + selected : '');
      // Shopify owns validation, consent and success. Never simulate a subscription.
    });
    const blocked = () => {
      const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      const cookieBanner = document.getElementById('shopify-pc__banner');
      const overlay = [...document.querySelectorAll('dialog[open],#menuDrawer.is-open,[aria-modal="true"]:not([hidden])')].some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      return overlay || document.body.classList.contains('reference-scroll-locked') || typing || (cookieBanner && cookieBanner.getClientRects().length);
    };
    const tick = () => {
      if (!popup.isConnected) { cleanup(); return; }
      const now = Date.now(), delta = Math.min(1000, Math.max(0, now - lastTick));
      lastTick = now;
      if (document.hidden) return;
      visit = policy.advance(read(visitKey), now, delta, timeout);
      write(visitKey, visit);
      if (forced || returned) { if (specialOpened) return; }
      else if (!policy.eligible(visit, subscribed(), delay)) return;
      if (blocked()) return;
      previousFocus = document.activeElement;
      scale(); popup.showModal();
      visit.shown = true;
      write(visitKey, visit);
      specialOpened = true;
      document.body.classList.add('bobbo-popup-open');
      popup.querySelector('[data-offer-close]')?.focus({ preventScroll: true });
    };
    const visibility = () => { lastTick = Date.now(); };
    const syncSubscriber = () => { if (subscribed() && popup.open && !success && !forced) popup.close(); };
    window.addEventListener('resize', scale);
    window.addEventListener('storage', syncSubscriber);
    document.addEventListener('visibilitychange', visibility);
    popup.closest('.shopify-section')?.addEventListener('shopify:section:unload', cleanup, { once: true });
    const timer = setInterval(tick, 500);
  }
  const initialize = () => document.querySelectorAll('[data-offer-popup]').forEach(initializePopup);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  // The copied announcement element has no registered custom-element runtime.
  if (!customElements.get('sht-ann-bar')) {
    document.querySelectorAll('sht-ann-bar').forEach(bar => {
      const track = bar.querySelector('.js-anmb-items');
      if (!track) return;
      track.setAttribute('aria-live', 'off');
      const sync = () => {
        const current = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        [...track.children].forEach((slide, index) => {
          slide.setAttribute('aria-hidden', String(index !== current));
          slide.querySelectorAll('a').forEach(link => link.tabIndex = index === current ? 0 : -1);
        });
      };
      track.addEventListener('scroll', sync, { passive: true });
      requestAnimationFrame(sync);
      const rotation = setInterval(() => {
        if (!bar.isConnected) { clearInterval(rotation); return; }
        if (document.hidden || bar.matches(':hover') || bar.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const index = (Math.round(track.scrollLeft / track.clientWidth) + 1) % track.children.length;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      }, 5000);
    });
  }
})();
